import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row',
        marginTop: 6
    },
    reportTitle:{
        fontSize: 12,
        textAlign: 'center',
        // textTransform: 'uppercase',
    },
    thankingMessage:{
        fontSize: 12,
        textAlign: 'center',
        margin: 'auto',
        // textTransform: 'uppercase',
    }
  });


  const InvoiceThankYouMsg = () => (
    <View style={styles.titleContainer}>
        {/* <Text style={styles.reportTitle}>Please make payment by bank transfer to the following account</Text> */}
        <Text style={styles.thankingMessage}>*******************</Text>
        <Text style={styles.thankingMessage}>Happy Conferencing!</Text>
        <Text style={styles.thankingMessage}>*******************</Text>
    </View>
  );
  
  export default InvoiceThankYouMsg